import { Avatar, Loader } from '@mantine/core';
import { safeImage } from '../utils';
import { useGetOrgProfileImageQuery } from '../api';
import { PLACEHOLDER_PROFILE_IMAGE } from '../constants';

interface Props {
  orgId: string;
  size?: number;
}

export const OrgAvatar = ({ orgId, size = 40 }: Props) => {
  const { data: avatar, isLoading } = useGetOrgProfileImageQuery(orgId);

  if (isLoading) {
    return <Loader size={size} />;
  }

  return (
    <Avatar
      radius="xl"
      size={size}
      src={safeImage(avatar?.image) || PLACEHOLDER_PROFILE_IMAGE}
      alt={`org avatar`}
    />
  );
};
